import { useState } from 'react'
import { isTransportError, useOpenWindow, useWindowShell } from '@krp/client-runtime'
import { cashierAnalyticsPatched, type CashierAnalyticsIntent } from '@krp/resource-receipts-ui'
import { lastOfMonth } from '@krp/ui-kit'
import { useAppDispatch, useAppSelector } from '../../app/hooks'

export const errorText = (error: unknown) => error === undefined ? null : isTransportError(error) ? error.message : error instanceof Error ? error.message : 'Не удалось получить ответ сервера'

export function todayIn(timeZoneId: string) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: timeZoneId, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date())
  return `${parts.find((part) => part.type === 'year')?.value ?? ''}-${parts.find((part) => part.type === 'month')?.value ?? ''}-${parts.find((part) => part.type === 'day')?.value ?? ''}`
}

export function useReportRange() {
  const dispatch = useAppDispatch()
  const intent = useAppSelector((state) => state.receipts.cashierAnalytics)
  const today = todayIn(intent.timeZoneId)
  const from = intent.from || today, to = intent.to || today
  const patch = (value: Partial<CashierAnalyticsIntent>) => {
    if (value.from !== undefined || value.to !== undefined) {
      const start = value.from ?? from, end = value.to ?? to
      value = { ...value, from: start, to: end > lastOfMonth(start) ? lastOfMonth(start) : end < start ? start : end }
    }
    dispatch(cashierAnalyticsPatched(value))
  }
  return { intent, today, from, to, patch }
}

export function useOriginal() {
  const shell = useWindowShell(), open = useOpenWindow()
  const [error, setError] = useState<string | null>(null)
  return { error, original: (path: string) => {
    const target = shell.match(path)
    if (target === undefined) { setError('Источник не зарегистрировал окно исходного чека'); return }
    setError(null); open(target.kind, target.params)
  } }
}
